const IMPORT = {
  OPEN_MODAL: 'Import > Open modal',
}
const IMPORT_DOCUMENT = 'Import document'

// Import V2
const IMPORT_OPTIONS = {
  IMPORT_ONLY: 'Import slides',
  IMPORT_AND_GENERATE: 'Import and generate slides with AI',
  GENERATE_ONLY: 'Generate interactive slides',
}

const IMPORT_ACTION_OPTIONS = [
  {
    value: IMPORT_OPTIONS.IMPORT_AND_GENERATE,
    isImport: true,
    tooltip: 'Import your file as slides, then AI will suggest and insert interactive ones after relevant sections.',
  },
  {
    value: IMPORT_OPTIONS.GENERATE_ONLY,
    isImport: false,
    tooltip: 'Use AI to create interactive slides from your file content, without importing the originals.',
  },
  {
    value: IMPORT_OPTIONS.IMPORT_ONLY,
    // No need to send data to AI Chatbot for this option, so isImport is not set here
    tooltip: 'Import your file exactly as it is. You can use AI to generate interactive slides later.',
  },
]

const CLOSE_IMPORT_MODAL = 'close-import-modal'
const CLOSE_UPLOAD_MODAL = 'close-upload-modal'
const CLICK_BROWSE_FILE = 'click-browse-file'
const UPLOAD_FILE_STARTED = 'upload-file-started'
const UPLOAD_FILE_SUCCESSFUL = 'upload-file-successful'
const UPLOAD_FILE_FAILED = 'upload-file-failed'
const START_IMPORTING = 'start-importing'

export {
  IMPORT,
  IMPORT_DOCUMENT,

  // Import V2
  IMPORT_OPTIONS,
  IMPORT_ACTION_OPTIONS,
  CLOSE_IMPORT_MODAL,
  CLOSE_UPLOAD_MODAL,
  CLICK_BROWSE_FILE,
  UPLOAD_FILE_STARTED,
  UPLOAD_FILE_SUCCESSFUL,
  UPLOAD_FILE_FAILED,
  START_IMPORTING,
}
